module.exports = __webpack_public_path__ + "img/header_bar.024b2c35.jpg";